import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.innovationbrindes.com.br/api',
})

export const fetchCategories = async () => {
  try {
    const response = await api.get('/categories')
    return response.data
  } catch (error) {
    console.error('Erro ao buscar categorias:', error)
    return [
      { id: 1, value: 'abstract', label: 'Abstrato' },
      { id: 2, value: 'floral', label: 'Floral' },
      { id: 3, value: 'geometric', label: 'Geométrico' },
      { id: 4, value: 'urban', label: 'Urbano' },
      { id: 5, value: 'dogs', label: 'Dogs' },
    ]
  }
}

export const fetchThemes = async () => {
  try {
    const response = await api.get('/themes')
    return response.data
  } catch (error) {
    console.error('Erro ao buscar temas:', error)
    return [
      { id: 1, value: 'estilizado', label: 'Estilizado' },
      { id: 2, value: 'minimalista', label: 'Minimalista' },
      { id: 3, value: 'colorido', label: 'Colorido' },
      { id: 4, value: 'neon', label: 'Neon' },
    ]
  }
}

export const fetchArtGallery = async (params = {}) => {
  try {
    const { categoria, tema } = params
    let url = '/artGallery'

    if (categoria || tema) {
      const queryParams = new URLSearchParams()
      if (categoria) queryParams.append('category', categoria)
      if (tema) queryParams.append('theme', tema)
      url += `?${queryParams.toString()}`
    }

    const response = await api.get(url)
    return response.data
  } catch (error) {
    console.error('Erro ao buscar galeria de artes:', error)
    return []
  }
}

export const generateImages = async (formData) => {
  try {
    const payload = {
      prompt: formData.prompt,
      estilo_artistico: formData.estiloArtistico,
      variedade_visual: formData.variedadeVisual,
      criatividade: formData.criatividade,
      categoria: formData.categoria,
      tema_linha: formData.tema,
      produto: formData.produto,
    }

    const requestFormData = new FormData()
    requestFormData.append('criatividade', formData.criatividade)
    requestFormData.append('prompt', formData.prompt)
    requestFormData.append('estilo_artistico', formData.estiloArtistico)
    requestFormData.append('variedade_visual', formData.variedadeVisual)
    requestFormData.append('categoria', formData.categoria)
    requestFormData.append('tema_linha', formData.tema)
    requestFormData.append('produto', formData.produto)
    if (formData.files && formData.files.length > 0) {
      formData.files.forEach((file, index) => {
        requestFormData.append(`imagem[]`, file)
      })
    }

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }

    const response = await api.post('/site/v2/controle-imagens-ia/gerar-imagem-prompt-imagem', requestFormData, config)
    return response.data
  } catch (error) {
    console.error('Erro ao gerar imagens:', error)

    return {
      success: true,
      images: [
        { id: 1, url: 'https://via.placeholder.com/400x400/FFEB3B/000000?text=Arte+1', backgroundColor: '#FFEB3B' },
        { id: 2, url: 'https://via.placeholder.com/400x400/4F6272/FFFFFF?text=Arte+2', backgroundColor: '#4F6272' },
        { id: 3, url: 'https://via.placeholder.com/400x400/FFB74D/000000?text=Arte+3', backgroundColor: '#FFB74D' },
        { id: 4, url: 'https://via.placeholder.com/400x400/303F9F/FFFFFF?text=Arte+4', backgroundColor: '#303F9F' },
      ],
    }
  }
}

export const fetchProducts = async () => {
  try {
    const response = await api.get('/products')
    return response.data
  } catch (error) {
    console.error('Erro ao buscar produtos:', error)
    return [
      { id: 1, value: 'copo', label: 'Copo', aspectRatio: '16:9' },
      { id: 2, value: 'squeeze', label: 'Squeeze', aspectRatio: '4:3' },
      { id: 3, value: 'caneca', label: 'Caneca', aspectRatio: '1:1' },
      { id: 4, value: 'todos', label: 'Gerar Para Todos os Produtos', aspectRatio: null },
    ]
  }
}

export const getProductByValue = (products, value) => {
  return products.find((product) => product.value === value) || null
}

export const getAspectRatio = (products, productValue) => {
  const product = getProductByValue(products, productValue)
  return product ? product.aspectRatio : null
}

export default api
